import React, { Component } from "react";
import { Badge, Dropdown } from "react-bootstrap";
import configData from "../config.json";

export default class NotificationsPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      notifications: [],
      unreadCount: 0,
    };
    this.pollInterval = null;
  }

  componentDidMount() {
    this.fetchNotifications();
    // Poll every 30 seconds
    this.pollInterval = setInterval(this.fetchNotifications, 30000);
  }

  componentWillUnmount() {
    if (this.pollInterval) clearInterval(this.pollInterval);
  }

  fetchNotifications = () => {
    const frmdata = new FormData();
    frmdata.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentnotifications/unread", {
      method: "POST",
      body: frmdata,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({
            notifications: data.list || [],
            unreadCount: data.unreadCount || 0,
          });
        }
      })
      .catch((error) => console.error("Notification fetch error:", error));
  };

  markAsRead = (notifId) => {
    const frmdata = new FormData();
    frmdata.append("deploymentnotifications_Id", notifId);
    fetch(configData.api_url + "C_Deploymentnotifications/markread", {
      method: "POST",
      body: frmdata,
    })
      .then((response) => response.json())
      .then(() => this.fetchNotifications())
      .catch((error) => console.error("Error:", error));
  };

  markAllRead = () => {
    const frmdata = new FormData();
    frmdata.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentnotifications/markallread", {
      method: "POST",
      body: frmdata,
    })
      .then((response) => response.json())
      .then(() => this.fetchNotifications())
      .catch((error) => console.error("Error:", error));
  };

  getNotifIcon = (type) => {
    const icons = {
      CrossTeamAssignment: "bi-people-fill",
      ApprovalRequired: "bi-clipboard-check",
      RequestApproved: "bi-check-circle-fill",
      RequestRejected: "bi-x-circle-fill",
      DeploymentReady: "bi-rocket-takeoff",
      DeploymentComplete: "bi-check2-all",
    };
    return icons[type] || "bi-bell-fill";
  };

  getNotifColor = (type) => {
    const colors = {
      CrossTeamAssignment: "#ffc107",
      ApprovalRequired: "#0dcaf0",
      RequestApproved: "#198754",
      RequestRejected: "#dc3545",
      DeploymentReady: "#fd7e14",
      DeploymentComplete: "#198754",
    };
    return colors[type] || "#6c757d";
  };

  render() {
    const { notifications, unreadCount } = this.state;

    return (
      <Dropdown align="end">
        <Dropdown.Toggle
          variant="link"
          id="notification-dropdown"
          className="position-relative text-decoration-none"
          style={{ color: "#333" }}
        >
          <i className="bi bi-bell" style={{ fontSize: "1.2rem" }}></i>
          {unreadCount > 0 && (
            <Badge
              bg="danger"
              pill
              className="position-absolute"
              style={{ top: "0", right: "0", fontSize: "0.6rem" }}
            >
              {unreadCount}
            </Badge>
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu
          style={{
            width: "380px",
            maxHeight: "400px",
            overflowY: "auto",
          }}
        >
          <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
            <strong>Notifications</strong>
            {unreadCount > 0 && (
              <small
                className="text-primary"
                style={{ cursor: "pointer" }}
                onClick={this.markAllRead}
              >
                Mark all read
              </small>
            )}
          </div>

          {notifications.length === 0 ? (
            <div className="text-center py-3 text-muted">
              No new notifications
            </div>
          ) : (
            notifications.map((notif) => (
              <Dropdown.Item
                key={notif.deploymentnotifications_Id}
                onClick={() =>
                  this.markAsRead(notif.deploymentnotifications_Id)
                }
                className="py-2 border-bottom"
                style={{ whiteSpace: "normal" }}
              >
                <div className="d-flex align-items-start">
                  <i
                    className={`${this.getNotifIcon(notif.notificationType)} me-2 mt-1`}
                    style={{
                      color: this.getNotifColor(notif.notificationType),
                    }}
                  ></i>
                  <div>
                    <small className="d-block">{notif.message}</small>
                    <small className="text-muted">
                      {notif.createdOn}
                    </small>
                  </div>
                </div>
              </Dropdown.Item>
            ))
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}
